import { Link, useLocation } from 'react-router-dom';
import { IconSparkles, IconHome, IconInfoCircle, IconMap2, IconPhoto, IconPhone, IconLogin } from '@tabler/icons-react';
import { ThemeToggle } from './ThemeToggle';

export const Navigation = () => {
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  // Hide landing navigation on admin/master pages
  const isAdminOrMasterPage = location.pathname === '/admin' || location.pathname === '/master';
  
  const navLinks = [
    { path: '/', label: 'Главная', icon: IconHome },
    { path: '/about', label: 'О нас', icon: IconInfoCircle },
    { path: '/addresses', label: 'Адреса', icon: IconMap2 },
    { path: '/gallery', label: 'Галерея', icon: IconPhoto },
    { path: '/contacts', label: 'Контакты', icon: IconPhone },
  ];

  return (
    <header className="border-b-[0.5px] border-[color:hsl(var(--hairline))] bg-card/60 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-16 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <IconSparkles size={28} className="text-[color:hsl(var(--brand-orange))] group-hover:rotate-12 transition-transform duration-200 max-[768px]:w-8 max-[768px]:h-8" stroke={1.75} />
            <div>
              <h1 className="font-['Playfair_Display'] text-xl font-semibold max-[768px]:text-2xl">РИО</h1>
              <p className="text-[10px] text-[color:hsl(var(--foreground))]/60 -mt-1 max-[768px]:text-xs">Сеть парикмахерских коворкингов</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          {!isAdminOrMasterPage && (
            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map(({ path, label, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`px-4 py-2 rounded-[12px] text-sm font-medium transition-colors duration-200 flex items-center gap-2 ${
                  isActive(path)
                    ? 'bg-[color:hsl(var(--brand-orange))] text-white'
                    : 'text-[color:hsl(var(--foreground))]/70 hover:text-[color:hsl(var(--foreground))] hover:bg-[color:hsl(var(--muted))]'
                }`}
                data-testid={`nav-link-${path.slice(1) || 'home'}`}
              >
                <Icon size={16} />
                {label}
              </Link>
              ))}
            </nav>
          )}

          {/* Right side */}
          <div className="flex items-center gap-3">
            {/* Phone */}
            <a
              href="tel:+78462028880"
              className="hidden lg:flex items-center gap-2 px-4 py-2 text-sm font-medium text-[color:hsl(var(--foreground))]/70 hover:text-[color:hsl(var(--brand-orange))] transition-colors"
            >
              <IconPhone size={16} />
              <span>8 (846) 202-88-80</span>
            </a>

            <ThemeToggle />

            {/* Login dropdown */}
            <div className="relative group">
              <button
                className="inline-flex items-center gap-2 px-4 h-9 rounded-[12px] border-[0.5px] border-[color:hsl(var(--hairline))] hover:border-[color:hsl(var(--brand-orange))] transition-[border-color] duration-200"
                data-testid="login-dropdown"
              >
                <IconLogin size={16} />
                <span className="text-sm hidden sm:inline">Вход</span>
              </button>
              
              {/* Dropdown menu */}
              <div className="absolute right-0 mt-2 w-48 bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[16px] shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="p-2">
                  <Link
                    to="/admin"
                    className="block px-4 py-2 text-sm rounded-[12px] hover:bg-[color:hsl(var(--muted))] transition-colors"
                    data-testid="login-admin-link"
                  >
                    Вход для администратора
                  </Link>
                  <Link
                    to="/master"
                    className="block px-4 py-2 text-sm rounded-[12px] hover:bg-[color:hsl(var(--muted))] transition-colors"
                    data-testid="login-master-link"
                  >
                    Вход для мастера
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {!isAdminOrMasterPage && (
          <nav className="md:hidden pb-3 -mx-4 px-4 flex gap-2 overflow-x-auto" style={{scrollbarWidth: 'none', msOverflowStyle: 'none'}}>
            {navLinks.map(({ path, label, icon: Icon }) => (
            <Link
              key={path}
              to={path}
              className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-colors duration-200 flex items-center gap-1.5 flex-shrink-0 ${
                isActive(path)
                  ? 'bg-[color:hsl(var(--brand-orange))] text-white'
                  : 'bg-[color:hsl(var(--muted))] text-[color:hsl(var(--foreground))]/70'
              }`}
            >
              <Icon size={14} />
              {label}
            </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};
